import '../css/app.css';
import './main-nav';
import './modules/navigation.js';
import './modules/sliders.js';
import './modules/animations.js';
import { initVideoPlayers, destroyVideoPlayers } from './modules/videoplayers.js';
import { initNav } from './modules/navigation';
import { initAnimations, initHeaderScroll } from './modules/animations';
import { initSliders } from './modules/sliders';
import barba from '@barba/core';
import gsap from 'gsap';

// ----------------------------
// Helpers
// ----------------------------
// Init Sprig (htmx + Alpine)
function initSprig() {
    if (window.htmx) {
        window.htmx.process(document.body); // re-scan DOM
    }
    if (window.Alpine) {
        window.Alpine.flushAndStopDeferringMutations && window.Alpine.flushAndStopDeferringMutations();
        window.Alpine.initTree(document.body);
    }
}

// Overlay fade
function fadeOverlay(opacity = 0, duration = 0.5) {
    gsap.to('#page-overlay', {
        opacity,
        duration,
        ease: 'power2.inOut',
        pointerEvents: opacity === 0 ? 'none' : 'auto'
    });
}

// Update header theme (alle headers met data-theme)
function updateHeaderTheme(container) {
    if (!container) return;
    const headers = container.querySelectorAll('header[data-theme]');
    headers.forEach(header => {
        const theme = header.dataset.theme || 'light';
        header.classList.remove('dark', 'light');
        header.classList.add(theme);
    });
}

// Menu highlighting
function setActiveMenu(url) {
    const links = document.querySelectorAll('.update-nav a');
    links.forEach(link => {
        link.classList.remove('active-state-menu-state');
        if (link.pathname === new URL(url).pathname) {
            link.classList.add('active-state-menu-state');
        }
    });
}

function setActiveTopMenu(url) {
    const links = document.querySelectorAll('.update-top-nav a');
    links.forEach(link => {
        link.classList.remove('active-top-menu');
        if (link.pathname === new URL(url).pathname) {
            link.classList.add('active-top-menu');
        }
    });
}

// Simple wait
function wait(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

// ----------------------------
// First load (refresh)
// ----------------------------
window.addEventListener('DOMContentLoaded', async () => {
    const wrapper = document.querySelector('#barba-wrapper');

    // Content meteen zichtbaar
    if (wrapper) gsap.set(wrapper, { opacity: 1 });

    // Overlay fade-out
    fadeOverlay(0, 0.5);

    // Init navigation, animations, sliders
    initHeaderScroll();
    initAnimations();
    initSliders();
    initVideoPlayers();

    // Header theme & menu highlight
    if (wrapper) updateHeaderTheme(wrapper);
    setActiveTopMenu(window.location.href);
    setActiveMenu(window.location.href);

    // Remove loading class
    document.documentElement.classList.remove('page-is-loading');
});

// ----------------------------
// Barba.js transitions
// ----------------------------
barba.init({
    transitions: [{
        name: 'opacity-transition',

        async leave(data) {
            // Oude content fade-out
            window.scrollTo(0, 0);
        },

        enter(data) {
            // Nieuwe content start op 0
            gsap.set(data.next.container, { opacity: 0 });
        },

        async afterEnter({ next }) {
            initSprig(); // re-init Sprig after new page is in DOM
            const container = next.container;
            const url = window.location.href;

            // Header theme update
            updateHeaderTheme(container);

            // Content fade-in
            gsap.set(container, { opacity: 1 });

            // Overlay fade-out
            fadeOverlay(0, 0.5);

            // ScrollTrigger cleanup
            const { ScrollTrigger } = await import('gsap/ScrollTrigger');
            ScrollTrigger.getAll().forEach(trigger => trigger.kill());

            await wait(50);

            // Init navigation, animations, sliders opnieuw
            await initNav(next.container);
            initHeaderScroll(next.container);
            await initAnimations();
            await initSliders();
            destroyVideoPlayers();
            initVideoPlayers();
            ScrollTrigger.refresh(true);

            // Menu highlight
            setActiveTopMenu(url);
            setActiveMenu(url);
        }
    }]
});
